import auth from '../auth'
import React, { Component } from 'react'
import { browserHistory, Link } from 'react-router'
import { grey300 } from 'material-ui/styles/colors'
import { Card, CardTitle, CardText } from 'material-ui/Card'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import ClearFix from 'material-ui/internal/ClearFix'
import muiThemeable from 'material-ui/styles/muiThemeable'

class Login extends Component<any, any> {
  static childContextTypes = {
    muiTheme: React.PropTypes.object
  }

  componentWillMount () {
    this.setState({
      muiTheme: getMuiTheme()
    })
  }

  getChildContext () {
    return {
      muiTheme: this.state.muiTheme
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      user: '',
      pass: ''
    }
  }

  handleUserChange (event) {
    this.setState({
      user: event.target.value
    })
  }

  handlePassChange (event) {
    this.setState({
      pass: event.target.value
    })
  }

  handleSubmit (event) {
    event.preventDefault()
    auth.login(this.state.user, this.state.pass, (loggedIn) => {
      if (!loggedIn) {
        return this.setState({ error: true })
      }

      this.setState({ error: false })
      browserHistory.push('/')
    })
  }

  render () {
    const style = {
      root: {
        width: '100%',
        height: '100%',
        background: grey300
      },
      container: {
        width: 360,
        margin: '0 auto',
        padding: '100px 0'
      },
      card: {
      },
      title: {
        backgroundColor: this.props.muiTheme.palette.primary1Color
      },
      button: {
        float: 'right',
        marginTop: 14
      },
      forgotPassword: {
        display: 'block',
        marginTop: 20,
        color: 'black'
      }
    }

    return (
      <div style={style.root}>
        <div style={style.container}>
          <Card style={style.card}>
            <CardTitle title='Login' style={style.title} titleColor='white' />
            <CardText>
              <ClearFix>
                <form method='post' name='login' onSubmit={this.handleSubmit.bind(this)}>
                  <TextField name='username' floatingLabelText='Username' fullWidth errorText={this.state.error ? ' ' : ''} onChange={this.handleUserChange.bind(this)} />
                  <TextField name='password' floatingLabelText='Password' type='password' fullWidth errorText={this.state.error ? 'Invalid username or password' : ''} onChange={this.handlePassChange.bind(this)} />
                  <RaisedButton label='Login' style={style.button} type='submit' />
                </form>
                <Link style={style.forgotPassword} to='/reset-password'>Forgot password?</Link>
              </ClearFix>
            </CardText>
          </Card>
        </div>
      </div>
    )
  }
}

export default muiThemeable()(Login)
